export default __webpack_public_path__ + "static/media/Familiarization_Programme_for_Independent_Directors_2.e9ac1706.pdf";